<template>
  <div>
    <modal
      name="modal_calendar"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <DateSelector v-on:update:dates="datesChange"></DateSelector>
    </modal>

    <div class="col">
      <div class="row">
        <div class="col">
          <button
            class="btn btn-secondary dropdown-toggle mobile"
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
            v-on:click="openCalendar"
          >
            {{ dateStart }} até {{ dateEnd }}
          </button>
        </div>
      </div>
    </div>

    <div class="sized-top-20" v-if="is_loading == true">
      <div class="loader"></div>
    </div>
    <div id="finalize" v-else-if="travels.length > 0">
      <div class="row justify-content-md-center" v-if="getSumTravels != null">
        <div class="col-md-auto">
          No dinheiro: {{ getSumTravels.money.i }} - R${{
            getSumTravels.money.t.toFixed(2)
          }}
        </div>
        <div class="col-md-auto">
          No cartão: {{ getSumTravels.card.i }} - R${{
            getSumTravels.card.t.toFixed(2)
          }}
        </div>
        <div class="col-md-auto">
          No cashback: {{ getSumTravels.cash.i }} - R${{
            getSumTravels.cash.t.toFixed(2)
          }}
        </div>
        <div class="col-md-auto">
          Canceladas: {{ getSumTravels.cancel.i }} - R${{
            getSumTravels.cancel.t.toFixed(2)
          }}
        </div>
      </div>
      <Travel
        class="sized-top-20"
        v-for="travel in travels"
        :key="travel.key"
        v-bind:travel="travel"
      ></Travel>
    </div>
    <div class="sized-top-20" v-else>
      <span class="text-bold"
        >Você não tem corridas finalizas, vamos começar? Clique em solicitar
        corrida</span
      >
    </div>
  </div>
</template>

<script>
import { db } from "../configs/firebase.js";
import Travel from "../components/Travel.vue";
import DateSelector from "../components/DateSelector.vue";
import moment from "moment-timezone";

export default {
  name: "Finalize",
  data() {
    return {
      selectStart: null,
      selectEnd: null,
      is_loading: false,
      travels: [],
    };
  },
  components: {
    Travel,
    DateSelector,
  },
  computed: {
    dateStart: function() {
      try {
        return moment(this.selectStart).format("DD/MM/YYYY");
      } catch (e) {
        //console.log(e);
        return "--/--/----";
      }
    },
    dateEnd: function() {
      try {
        return moment(this.selectEnd).format("DD/MM/YYYY");
      } catch (e) {
        //console.log(e);
        return "--/--/----";
      }
    },
    getSumTravels: function() {
      try {
        if (this.travels.length > 0) {
          let sum = {
            money: {
              i: 0,
              t: 0,
            },
            cash: {
              i: 0,
              t: 0,
            },
            card: {
              i: 0,
              t: 0,
            },
            cancel: {
              i: 0,
              t: 0,
            },
          };

          this.travels.forEach((travel) => {
            if (travel.data.keys.stats == 2) {
              if (travel.data.payment == "0") {
                sum.money.i++;
                sum.money.t += travel.data.value;
              } else if (travel.data.payment == "1") {
                sum.card.i++;
                sum.card.t += travel.data.value;
              } else if (travel.data.payment == "2") {
                sum.cash.i++;
                sum.cash.t += travel.data.value;
              }
            } else if (travel.data.keys.stats == 3) {
              sum.cancel.i++;
              sum.cancel.t += travel.data.value;
            }
          });

          return sum;
        } else {
          return null;
        }
      } catch (e) {
        return null;
      }
    },
    user: function() {
      return this.$root.user;
    },
  },
  methods: {
    datesChange(dates) {
      this.selectStart = dates[0];
      this.selectEnd = dates[1];

      this.getTravels();
    },
    openCalendar() {
      this.$modal.show("modal_calendar");
    },
    async getTravels() {
      try {
        this.is_loading = true;

        this.travels = [];

        let q_finalize = await db
          .ref("travels")
          .orderByChild("keys/user_create")
          .startAt(this.user.uid + "___" + this.selectStart)
          .endAt(this.user.uid + "___" + this.selectEnd)
          .once("value");

        let count = 0;

        q_finalize.forEach((s_travel) => {
          let travel = {
            key: s_travel.key,
            data: s_travel.val(),
          };

          if (travel.data.keys.stats > 1) {
            if (travel.data.keys.stats == 2 && travel.data.rating == null) {
              count++;
            }

            this.travels.push(travel);
          }
        });

        if (count > 0) {
          alert("Você tem " + count + " corridas sem avaliação!");
        }
      } catch (e) {
        //console.log(e);
      } finally {
        this.travels.sort(function(x, y) {
          return y.data.dates.create - x.data.dates.create;
        });

        this.is_loading = false;
      }
    },
  },
  watch: {
    user() {
      this.getTravels();
    },
  },
  created() {
    let now = new Date();

    this.selectStart = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
      1
    ).getTime();

    this.selectEnd = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    ).getTime();

    this.getTravels();
  },
};
</script>

<style>
#finalize {
  text-align: left;
  margin: 20px auto;
  max-width: 912px;
}

@media only screen and (max-width: 912px) {
  #finalize {
    width: 100%;
    padding: 0px;
  }
}
</style>
